export default function ({ urlStock, loadingTextStock }) {
    return {
        qty: 1,
        reviewsIsOpen: false,
        questionsAndAnswersIsOpen: true,
        loadingStock: true,
        showTooltipStock: false,
        contentTooltipStock: loadingTextStock,
        productInStock: false,
        init() {
            this.getStockInformation();
            window.addEventListener('reviewsIsOpen', (event) => {
                this.reviewsIsOpen = event.detail;
            });
        },
        incrementQty() {
            this.qty++;
        },
        decrementQty() {
            if (this.qty > 1) {
                this.qty--;
            }
        },
        inputQtyChanged() {
            if (this.qty < 1) {
                this.qty = 1;
            }
        },
        getStockInformation() {
            try {
                fetch(urlStock, {
                    method: 'GET',
                    cache: 'no-store'
                })
                    .then((response) => response.json())
                    .then((data) => {
                        this.loadingStock = false;
                        if (data.content.length > 0) {
                            this.contentTooltipStock = data.content;
                            this.productInStock = data.inStock;
                            this.showTooltipStock = true;
                        }
                    });
            } catch (error) {
                console.error(error);
            }
        }
    };
}
